import { useState } from 'react';

import {
  ChakraBox,
  ChakraFlex,
  FireflyButton,
  Text,
  TextInputV2,
  useToastMessage,
} from '@equip.health/ui';

import { useLazyGetBulkProviderTeamAssignmentsByJobKeyQuery } from '~/store/services/techOps';

import JobStatusModal from './JobStatusModal';
import { TechOpsToasts } from './toastMessages';

type PollJobStatusProps = {
  topLevelId: string;
};

const PollJobStatus = ({ topLevelId }: PollJobStatusProps) => {
  const [pollJobKey, setPollJobKey] = useState<string>('');
  const [jobStatus, setJobStatus] = useState<OpsBulkJobStatusResponse | null>(
    null,
  );
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { createToast } = useToastMessage();
  const [fetchJobStatus, { isLoading: isPolling }] =
    useLazyGetBulkProviderTeamAssignmentsByJobKeyQuery();

  const handlePollJob = async () => {
    const trimmedKey = pollJobKey.trim();
    if (!trimmedKey) {
      return;
    }

    try {
      const data = await fetchJobStatus(trimmedKey).unwrap();
      setJobStatus(data);
      setIsModalOpen(true);
    } catch (error) {
      if (error?.status === 404) {
        createToast(TechOpsToasts.pollJob.notFound(trimmedKey));
      } else {
        createToast(TechOpsToasts.pollJob.error(trimmedKey));
      }
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setJobStatus(null);
  };

  return (
    <>
      <ChakraBox
        background="neutral.background.secondary"
        borderRadius="8px"
        flex="1"
        padding="24px"
      >
        <Text marginBottom="16px" variant="h5">
          Poll Job Status
        </Text>

        <ChakraFlex alignItems="center" gap="16px">
          <ChakraBox flex="1">
            <TextInputV2
              id={`${topLevelId}-poll-job-key-input`}
              onChange={(value) => setPollJobKey(value)}
              placeholder="Enter job key"
              value={pollJobKey}
            />
          </ChakraBox>
          <FireflyButton
            id={`${topLevelId}-poll-job`}
            isDisabled={!pollJobKey.trim() || isPolling}
            isLoading={isPolling}
            onClick={handlePollJob}
          >
            Check Status
          </FireflyButton>
        </ChakraFlex>
      </ChakraBox>

      <JobStatusModal
        isOpen={isModalOpen}
        jobStatus={jobStatus}
        onClose={handleCloseModal}
        topLevelId={topLevelId}
      />
    </>
  );
};

export default PollJobStatus;
